/** Putopis Segovia — jedan izvor za galeriju i video (Travelogues + Tours). */
export const SEGOVIA_TRAVELOGUE_GALLERY = [
  "/images/segovia/segovia.jpg",
  "/images/madrid-vinograda/1000108848.jpg",
  "/images/segovia/segovia1.jpg",
  "/images/segovia/segovia2.jpg",
  "/images/segovia/20250829_133644.jpg",
  "/images/segovia/20250829_134831.jpg",
  "/images/segovia/20250829_165640.jpg",
];

export const SEGOVIA_TRAVELOGUE_VIDEOS = ["/videos/segovia/20250829_153003.mp4"];

export const SEGOVIA_TRAVELOGUE_MEDIA = [
  ...SEGOVIA_TRAVELOGUE_GALLERY,
  ...SEGOVIA_TRAVELOGUE_VIDEOS,
];
